export const monthTickIndexes = (length, maximum = 10) => {
  if (length <= 0) return [];
  if (length <= maximum) return Array.from({ length }, (_, index) => index);
  const step = Math.ceil((length - 1) / (maximum - 1));
  const indexes = [];
  for (let index = 0; index < length; index += step) indexes.push(index);
  if (indexes[indexes.length - 1] !== length - 1) indexes.push(length - 1);
  return indexes;
};

export const formatMonthTick = month => {
  const [year, monthNumber] = String(month).split('-').map(Number);
  if (!year || !monthNumber) return String(month);
  return new window.Intl.DateTimeFormat('en-GB', { month: 'short', year: '2-digit', timeZone: 'UTC' }).format(new Date(Date.UTC(year, monthNumber - 1, 1)));
};
